import * as React from 'react'
import styled from '@theme/styled-components'
import Theme from '@theme/Theme'

import Switch from 'react-switch'

interface Props {
  value: boolean
  setValue: (b: boolean) => void

  height?: number
  width?: number
  handleDiameter?: number

  onColor?: string
  offColor?: string

  label?: string
  labelFont?: Font
  labelColor?: string
}

const CustomSwitch = ({
  value,
  setValue,
  height = 20,
  width = 39,
  handleDiameter = 14,
  onColor = Theme.colors.primary_blue,
  offColor = Theme.colors.disabled,
  label,
  labelFont = Theme.fonts.label,
  labelColor = Theme.colors.primary_blue,
}: Props) => (
  <MainContainer>
    <Switch
      checkedIcon={false}
      uncheckedIcon={false}
      handleDiameter={handleDiameter}
      onColor={onColor}
      offColor={offColor}
      checked={value}
      onChange={() => setValue(!value)}
      height={height}
      width={width}
    />

    {!!label && (
      <Label font={labelFont} color={labelColor}>
        {label}
      </Label>
    )}
  </MainContainer>
)

const MainContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
`
const Label = styled('p')<{ font: Font; color: string }>`
  ${(props) => props.font};
  color: ${(props) => props.color};
  margin: 0px 0px 0px 14px;
`

export default CustomSwitch
